import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Globe, MessageCircle, Clock, Cog, Youtube, Send, Linkedin, Facebook } from 'lucide-react';
import { useLang } from '../i18n/LanguageContext';

const Footer = () => {
  const { t, isRTL } = useLang();
  return (
    <footer className="bg-[#061020] border-t border-blue-900/30 pt-12 pb-6">
      <div className="site-container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div className={isRTL ? 'text-right' : 'text-left'}>
            <div className={`flex items-center gap-2 mb-4 ${isRTL ? 'flex-row-reverse' : ''}`}>
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center">
                <Cog className="w-5 h-5 text-white" />
              </div>
              <span className="text-white font-bold text-lg">{t.footer.brand}</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-4">{t.footer.desc}</p>
            <div className={`flex items-center gap-2 ${isRTL ? 'flex-row-reverse' : ''}`}>
              <a href="#" className="w-9 h-9 rounded-lg bg-[#0e1c33] border border-blue-900/40 flex items-center justify-center text-slate-300 hover:text-red-400 hover:border-red-500/40 transition-colors"><Youtube className="w-4 h-4" /></a>
              <a href="#" className="w-9 h-9 rounded-lg bg-[#0e1c33] border border-blue-900/40 flex items-center justify-center text-slate-300 hover:text-blue-400 hover:border-blue-500/40 transition-colors"><Send className="w-4 h-4" /></a>
              <a href="#" className="w-9 h-9 rounded-lg bg-[#0e1c33] border border-blue-900/40 flex items-center justify-center text-slate-300 hover:text-blue-400 hover:border-blue-500/40 transition-colors"><Linkedin className="w-4 h-4" /></a>
              <a href="#" className="w-9 h-9 rounded-lg bg-[#0e1c33] border border-blue-900/40 flex items-center justify-center text-slate-300 hover:text-blue-400 hover:border-blue-500/40 transition-colors"><Facebook className="w-4 h-4" /></a>
            </div>
          </div>

          {/* Quick links */}
          <div className={isRTL ? 'text-right' : 'text-left'}>
            <h4 className="text-white font-bold mb-4">{t.footer.quickLinks}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-slate-400 hover:text-blue-400 transition-colors">{t.nav.home}</Link></li>
              <li><Link to="/courses" className="text-slate-400 hover:text-blue-400 transition-colors">{t.nav.courses}</Link></li>
              <li><Link to="/library" className="text-slate-400 hover:text-blue-400 transition-colors">{t.nav.library}</Link></li>
              <li><Link to="/subscription" className="text-slate-400 hover:text-blue-400 transition-colors">{t.nav.subscription}</Link></li>
            </ul>
          </div>

          {/* Help */}
          <div className={isRTL ? 'text-right' : 'text-left'}>
            <h4 className="text-white font-bold mb-4">{t.footer.help}</h4>
            <ul className="space-y-2 text-sm">
              <li><a className="text-slate-400 hover:text-blue-400 transition-colors cursor-pointer">{t.footer.faq}</a></li>
              <li><a className="text-slate-400 hover:text-blue-400 transition-colors cursor-pointer">{t.footer.privacy}</a></li>
              <li><a className="text-slate-400 hover:text-blue-400 transition-colors cursor-pointer">{t.footer.terms}</a></li>
              <li><a className="text-slate-400 hover:text-blue-400 transition-colors cursor-pointer">{t.footer.refund}</a></li>
              <li><a className="text-slate-400 hover:text-blue-400 transition-colors cursor-pointer">{t.footer.support}</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className={isRTL ? 'text-right' : 'text-left'}>
            <h4 className="text-white font-bold mb-4">{t.footer.contact}</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li className={`flex items-center gap-2 ${isRTL ? 'flex-row-reverse' : ''}`}><Mail className="w-4 h-4 text-blue-400 shrink-0" /><a href={`mailto:${t.footer.email}`} dir="ltr" data-testid="footer-email" className="hover:text-blue-400 transition-colors">{t.footer.email}</a></li>
              <li className={`flex items-center gap-2 ${isRTL ? 'flex-row-reverse' : ''}`}><Globe className="w-4 h-4 text-blue-400 shrink-0" /><span data-testid="footer-phone">{t.footer.phone}</span></li>
              <li className={`flex items-center gap-2 ${isRTL ? 'flex-row-reverse' : ''}`}><MessageCircle className="w-4 h-4 text-blue-400 shrink-0" /><span data-testid="footer-address">{t.footer.address}</span></li>
              <li className={`flex items-center gap-2 ${isRTL ? 'flex-row-reverse' : ''}`}><Clock className="w-4 h-4 text-blue-400 shrink-0" /><span data-testid="footer-hours">{t.footer.hours}</span></li>
            </ul>
          </div>
        </div>

        <div className="section-divider mb-5" />
        <div className="text-center text-slate-500 text-xs">{t.footer.copyright}</div>
      </div>
    </footer>
  );
};

export default Footer;
